import React from 'react';
import Select, { components } from 'react-select';
import { useQuery } from '@apollo/client';
import { SAVED_SEARCHES_QUERY } from '@general/graphql/saved-searches.graph';
import { BodySmall } from '@react/styledComponents';
import SavedSearchCriteriaMenuList from './SavedSearchCriteriaMenuList';
import fonts from '@general/fonts';

const selectStyles = {
    control: styles => ({
        ...styles,
        backgroundColor: 'white',
        borderRadius: 0,
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: '#e4eaef',
        height: '56px',
        paddingLeft: '.7rem',
    }),
    input: styles => ({
        ...styles,
        fontFamily: fonts.sans,
    }),
    menu: styles => ({
        ...styles,
        zIndex: 9999,
        width: 479,
        right: 0,
    }),
    menuList: styles => ({
        ...styles,
        fontFamily: fonts.sans,
        zIndex: 9999,
        fontSize: '1rem',
    }),
    placeholder: styles => ({ ...styles, color: '#464a4c', fontFamily: fonts.sans }),
    singleValue: styles => ({ ...styles, fontFamily: fonts.sans }),
    valueContainer: styles => ({
        ...styles,
        padding: '0px',
        flexWrap: 'nowrap',
        fontFamily: fonts.sans,
        zIndex: 9999,
    }),
};

export default function SavedSearchesSelector({ onSearchSelect }) {
    const { loading, data: { savedSearches } = [] } = useQuery(SAVED_SEARCHES_QUERY);

    if (loading) {
        return null;
    }

    const options = savedSearches
        .filter(search => search.primaryInterest === 'SPACE')
        .map(search => ({
            value: search.id,
            label: search.title,
        }));

    const onChange = e => {
        const search = savedSearches.find(search => search.id === e.value);
        onSearchSelect(search);
    };

    return (
        <div style={{ borderBottom: '1px solid #D8D8D8', paddingBottom: '18px', marginBottom: '18px' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem', width: '100%', alignItems: 'center' }}>
                <BodySmall>View suggested properties based on your Connections: </BodySmall>
                <div style={{ width: 350 }}>
                    <Select
                        onChange={onChange}
                        styles={selectStyles}
                        options={options}
                        components={{ MenuList: SavedSearchCriteriaMenuList }}
                    />
                </div>
            </div>
        </div>
    );
};
